export default __webpack_public_path__ + "static/media/PRH9-Logo.607bc859.jpg";